import React, { useState } from 'react';
import TermsModal from './components/TermsModal';
import { useTermsAcceptance } from './hooks/useTermsAcceptance';
import FeedbackTab from './components/FeedbackTab';
import { useAuth } from './context/AuthContext.jsx';

/**
 * Wrapper component that manages Terms & Conditions modal
 * Shows modal after login if user hasn't accepted current terms version
 */
export default function AppWithTerms({ children }) {
  const { user, loading: authLoading } = useAuth();
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const { needsAcceptance, isChecking, acceptTerms } = useTermsAcceptance(user);
  const isSignedInUser = !!(user && !user.isAnonymous);

  const handleAcceptTerms = async (version) => {
    setIsSubmitting(true);
    try {
      await acceptTerms(version);
    } catch (error) {
      console.error('Failed to accept terms:', error);
      alert('Failed to save your acceptance. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  // Show terms modal only for non-anonymous signed-in users
  const shouldShowModal = !authLoading && isSignedInUser && needsAcceptance && !isChecking;

  return (
    <>
      {children}
      <FeedbackTab />
      {shouldShowModal && (
        <TermsModal onAccept={handleAcceptTerms} isSubmitting={isSubmitting} />
      )}
    </>
  );
}
